class SotpCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.sotp-carousel__track');
    this.previous = this.querySelector('[data-carousel-previous]');
    this.next = this.querySelector('[data-carousel-next]');
    if (!this.track || !this.previous || !this.next) return;

    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.previous.addEventListener('click', () => this.move(-1), options);
    this.next.addEventListener('click', () => this.move(1), options);
    this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
    this.resizeObserver = new ResizeObserver(() => this.updateControls());
    this.resizeObserver.observe(this.track);
    this.updateControls();
  }

  move(direction) {
    const card = this.track.firstElementChild;
    if (!card) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
    this.track.scrollBy({
      left: direction * rtl * (card.getBoundingClientRect().width + gap),
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  }

  updateControls() {
    const position = Math.abs(this.track.scrollLeft);
    const end = this.track.scrollWidth - this.track.clientWidth;
    this.previous.disabled = position < 2;
    this.next.disabled = position >= end - 2;
  }

  disconnectedCallback() {
    this.events?.abort();
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('sotp-carousel')) customElements.define('sotp-carousel', SotpCarousel);
